import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=198e55a6&scoped=true&lang=html&"
import script from "./RegisterForm.vue?vue&type=script&lang=js&"
export * from "./RegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterForm.css?vue&type=style&index=0&id=198e55a6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198e55a6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/generico/RegisterForm.vue
// module id = 36
// module chunks = 28